import { o as of, m as map, a as fold, b as findIndex } from '../Either-48abb652.js';
import { f as flow } from '../ReadonlyNonEmptyArray-0e481d0b.js';
import { isString, isArray, isNumber, isObject } from 'lodash';
import { f as firstRight } from '../fp-utils-24a5cc96.js';
import { modify } from './modify.js';
import 'ricos-schema';
import '../modifier-infra.js';
import '../index-a60c253d.js';
import '../ReadonlyRecord-86a56753.js';
import '../string-40bcd6bf.js';
import '../converters/generateRandomId.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const isIndexFound = (predicate) => flow(
  (content) => content.nodes,
  findIndex(predicate),
  fold(
    () => false,
    () => true
  )
);
const isIndexInRange = (index) => (content) => {
  var _a, _b;
  return isNumber(index) && index >= 0 && index < ((_b = (_a = content.nodes) == null ? void 0 : _a.length) != null ? _b : 0);
};
const insertNode = (node, index) => (content) => {
  var _a, _b, _c, _d;
  return __spreadProps(__spreadValues({}, content), {
    nodes: [...(_b = (_a = content.nodes) == null ? void 0 : _a.slice(0, index)) != null ? _b : [], node, ...(_d = (_c = content.nodes) == null ? void 0 : _c.slice(index)) != null ? _d : []]
  });
};
const insertNodeByKey = (node, nodeKey, isAfter = false) => (content) => modify(content).filter(({ id }) => id === nodeKey).set((n) => isAfter ? [n, node] : [node, n]);
function addNode({
  node,
  index,
  before,
  after,
  content
}) {
  var _a;
  return firstRight(content, __spreadProps(__spreadValues({}, content), { nodes: [...(_a = content == null ? void 0 : content.nodes) != null ? _a : [], node] }), [
    [isIndexInRange(index), insertNode(node, index)],
    [isIndexFound(({ id }) => id === before), insertNodeByKey(node, before, false)],
    [isIndexFound(({ id }) => id === after), insertNodeByKey(node, after, true)]
  ]);
}
const isTextData = (text) => !!(text == null ? void 0 : text.text) && !!(text == null ? void 0 : text.decorations);
const toTextData = (text) => ({ text, decorations: [] });
const isListItemData = (item) => isArray(item.text) && isObject(item.data);
const toListItemData = (data) => (text) => ({ data, text });
const emptyListItemData = { text: [], data: {} };
const toListDataArray = (items, data) => firstRight(
  items,
  [],
  [
    [isString, flow(toTextData, of, toListItemData(data), of)],
    [isTextData, flow(of, toListItemData(data), of)],
    [isListItemData, (i) => [i]],
    [
      isArray,
      flow(
        map(
          (item) => firstRight(item, emptyListItemData, [
            [isString, flow(toTextData, of, toListItemData(data))],
            [isTextData, flow(of, toListItemData(data))],
            [isListItemData, (i) => i]
          ])
        )
      )
    ]
  ]
);
const toTextDataArray = (text) => firstRight(
  text,
  [],
  [
    [isString, flow(toTextData, of)],
    [isTextData, (t) => [t]],
    [isArray, flow(map((t) => firstRight(t, t, [[isString, toTextData]])))]
  ]
);

export { addNode, toListDataArray, toTextDataArray };
//# sourceMappingURL=builder-utils.js.map
